/* eslint-disable dot-notation */
/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable import/extensions */
import { API } from 'aws-amplify';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}

export function taskCreation(body:any, query:any): Promise<any>
{
	return API.post('taskManagement', `/task${query}`, { body });
}

export function getTaskList(query): Promise<any>
{
	return API.get('taskManagement', `/task${query}`, init);
}

export function getTaskById(query): Promise<any>
{
	return API.get('taskManagement', `/getTaskById${query}`, init);
}

export function EditTask(body:any, query:any): Promise<any>
{
	return API.put('taskManagement', `/task${query}`, { body });
}

export function deleteTask(id:any, query:any): Promise<any>
{
	return API.del('taskManagement', `/task/${id}${query}`, init);
}

export function getOrganizationdata(): Promise<any>
{
	return API.get('taskManagement', '/getDepartment', init);
}

export function createRecognise(body:any, query:any): Promise<any>
{
	return API.post('taskManagement', `/recognition${query}`, { body });
}

export function getRecognise(query): Promise<any>
{
	return API.get('taskManagement', `/recognition${query}`, init);
}

export function getRecogniseCount(query): Promise<any>
{
	return API.get('taskManagement', `/recognition${query}`, init);
}
export function getEmployeeRecognization(query): Promise<any>
{
	return API.get('taskManagement', `/empRecognition${query}`, init);
}
